module.exports = __webpack_public_path__ + "static/logo-wbac-d8743fc20f70aff432c9d58079934c22.png";